function throttle(func, limit) {
    let lastFunc;
    let lastRan;
    return function() {
        const context = this;
        const args = arguments;
        if (!lastRan) {
            func.apply(context, args);
            lastRan = Date.now();
        } else {
            clearTimeout(lastFunc);
            lastFunc = setTimeout(() => {
                if ((Date.now() - lastRan) >= limit) {
                    func.apply(context, args);
                    lastRan = Date.now();
                }
            }, limit - (Date.now() - lastRan));
        }
    }
}

function setupVideoMouseover() {
    const videos = Array.from(document.querySelectorAll('video')); // Seleciona todos os vídeos e cria um array

    videos.forEach(video => {
        video.addEventListener('mouseover', function() {
            videos.forEach(v => {
                if (v !== this) { 
                    v.pause();
                    this.play();
                }
            });
        });
    });
}

document.addEventListener('DOMContentLoaded', setupVideoMouseover);


document.addEventListener('DOMContentLoaded', function() {
    const videos = document.querySelectorAll('.video_carousel_item');
    const videosMobile = document.querySelectorAll('.swiper-slide_carousel_video');
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    const isDesktop = window.innerWidth >= 1024 ? true : false;
    let isScrolling = true;


    function checkPosition() {
        if (!isScrolling) return;
        requestAnimationFrame(() => {
            const positionY = window.scrollY;

            if (isDesktop) {             
                videos.forEach((video, index) => {
                    let bounds = video.getBoundingClientRect();
                    let videoPosition = bounds.top + window.scrollY - 800;
                    let stopPosition = bounds.top + window.scrollY + 350;

                    if (positionY >= stopPosition) {
                        video.pause();
                    } else if (positionY >= videoPosition && !video.isPlaying) {
                        if (video.hasAttribute('muted') || !isMobile) {
                            videos.forEach((v) => {
                                v.pause();
                                v.isPlaying = false;
                            
                            })
                            videos[0].play();
                            video.isPlaying = true;
                            
                            isScrolling = false;

                            video.addEventListener('ended', () => {
                                video.isPlaying = false;
                                if (videos[index + 1] == undefined) {
                                    videos[0].play(); 
                                    videos[0].isPlaying = true;
                                } else {
                                    videos[index + 1].play();   
                                    videos[index + 1].isPlaying = true;                                                                                  
                                }
                            });     
                        }
                    } else {
                        video.pause();
                    }
                });
            }
            else {
                videosMobile.forEach(mVideo => {
                    const videoPositon = parseInt(mVideo.getBoundingClientRect().top + window.scrollY - 800);
                    const stopPosition = parseInt(mVideo.getBoundingClientRect().top + window.scrollY + 350);
                    let mobileVideo = mVideo.firstElementChild.firstElementChild;
                    console.log(mobileVideo)
                        if(positionY >= stopPosition) {
                            mobileVideo.pause();
                        } else if (positionY >= videoPositon && mVideo.classList.contains('swiper-slide-active')) {
                            mobileVideo.play();
                        } else {
                            mobileVideo.pause();
                        }
                });
            }
        });
    }
    
    const throttledCheckPosition = throttle(checkPosition, 1000);
    window.addEventListener('scroll', throttledCheckPosition);
    document.addEventListener('touchend', throttledCheckPosition);
});


